<template>
  <a-dropdown>
    <div class="wrapper">
      <create-company :visible.sync="visibleCreateCompany" />
      <div class="project-wrapper">
        <user-avatar :height="40" :width="40" :image-path="currentProject?.logo_url" />
        <div class="project-info">
          <p class="m-0" :style="{ fontSize: '16px' }">
            {{ currentProject?.name }}
          </p>
        </div>
      </div>
      <div class="action-button">
        <a-icon width="24" height="24" icon="heroicons-outline:switch-vertical" />
      </div>
    </div>
    <a-menu slot="overlay"
      ><template v-if="profiles.length"
        ><a-menu-item
          :disabled="loading"
          v-for="associate in profiles"
          :key="`${associate.id}`"
          @click="onAssociateChange(currentProject.id, associate.associate_number)"
        >
          <div class="project-wrapper">
            <user-avatar :height="32" :width="32" :image-path="currentProject?.logo_url" />
            <div class="project-info">
              <p :style="{ fontSize: '16px' }">{{ associate.first_name }} {{ associate.last_name }}</p>
              <p :style="{ color: '#999999' }">
                {{ associate.associate_number }}<a-divider type="vertical" />
                {{ associate.role.name }}
              </p>
            </div>
          </div> </a-menu-item
        ><a-divider class="m-0" type="horizontal" /></template
      ><a-menu-item
        v-for="project in filteredProjects"
        :key="project.id"
        :disabled="loading"
        @click="onProjectChange(project.id)"
      >
        <div class="project-wrapper">
          <user-avatar :height="32" :width="32" :image-path="project.logo_url" />
          <div class="project-info">
            <p class="m-0" :style="{ fontSize: '16px' }">
              {{ project.name }}
            </p>
          </div>
        </div></a-menu-item
      ><template v-if="hasAdminGroup"
        ><a-divider class="m-0" type="horizontal" /><a-menu-item @click="visibleCreateCompany = true">
          <div class="project-wrapper">
            <div :style="{ width: '32px', height: '32px' }" class="flex align-items-center justify-content-center">
              <a-icon width="24" height="24" icon="heroicons:folder-plus" />
            </div>
            <div class="project-info">
              <p class="m-0" :style="{ fontSize: '16px' }">Create New Project</p>
            </div>
          </div></a-menu-item
        ></template
      ></a-menu
    >
  </a-dropdown>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import UserAvatar from '../ui/user-avatar.vue'
import { Divider, Dropdown, Menu, notification } from 'ant-design-vue'
import ProjectCreate from '@/modules/project/components/project-create.vue'
import permissionMixin from '@/mixins/permissionMixin'

export default {
  components: {
    'a-dropdown': Dropdown,
    'a-menu': Menu,
    'a-menu-item': Menu.Item,
    'a-divider': Divider,
    'user-avatar': UserAvatar,
    'create-company': ProjectCreate
  },
  mixins: [permissionMixin],
  data() {
    return {
      visibleCreateCompany: false
    }
  },
  computed: {
    ...mapState({
      loading: state => state.applicationState.loading
    }),

    profiles() {
      return (this.$store.state.applicationState?.associate?.profiles ?? []).filter(
        item => item.associate_number !== this.$store.state.applicationState?.associate?.associate_number
      )
    },

    currentProject() {
      return this.$store.state.applicationState.currentProject
    },

    filteredProjects() {
      const allProjects = this.$store.state.applicationState?.allProjects
      const currentProjectId = this.currentProject?.id

      if (!Array.isArray(allProjects) || !currentProjectId) {
        return []
      }

      return allProjects
        .filter((item, index, self) => {
          return self.findIndex(project => project.id === item.id) === index
        })
        .filter(
          item =>
            item.id !== currentProjectId &&
            item.is_active_associate &&
            Array.isArray(item.permissions) &&
            item.permissions.some(perm => perm.group === 'administrator')
        )
    }
  },
  methods: {
    ...mapActions(['setLoading', 'switchAssociate', 'switchProject', 'loadApplicationState']),

    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    },

    async onAssociateChange(newProjectId, newAssociateNumber) {
      this.setLoading(true)

      try {
        await this.switchAssociate({
          project_id: newProjectId,
          current_associate_number: this.$store.state.applicationState.associate.associate_number,
          associate_number_to_switch: newAssociateNumber
        })

        await this.loadApplicationState()

        await this.$router.replace({ query: {} }).catch(() => {})

        this.showNotification('success', 'Success', `Associate successfully switched to ${newAssociateNumber}`)
      } catch (error) {
        this.showNotification('error', 'Error', typeof error === 'string' ? error : error.message)
      }
    },

    async onProjectChange(newProjectId) {
      this.setLoading(true)

      try {
        if (this.currentProject.id !== newProjectId) {
          await this.switchProject({
            project_id: newProjectId
          })
        }

        await this.$router.replace({ name: 'home', query: {} }).catch(() => {})

        await this.loadApplicationState()

        this.showNotification('success', 'Success', `Company successfully switched to ${this.currentProject?.name}`)
      } catch (error) {
        this.showNotification('error', 'Error', typeof error === 'string' ? error : error.message)
      }
    }
  }
}
</script>

<style scoped>
.wrapper {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.project-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.project-info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
